import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    fetchedLabelTypes,
    fetchedLabel,
    createdLabel,
    updatedLabel,
    deletedLabel,
    fetchedLabelTranslations,
    fetchedLabelTranslation,
    deletedLabelTranslation
} from './actions';

export function fetchLabel(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${id}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedLabel(response.data)))
    }
}

export function fetchLabelTypes() {
    return dispatch => {

        let options = {
            url: `${ROOT_URL}/label-types`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => {dispatch(fetchedLabelTypes(response.data));})
    }
}

export function createLabel(label) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels`,
            method: 'POST',
            data: {
                name: label.display_name,
                label_type_id: label.label_type_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(createdLabel(response)))
            .then(() => toastr.success('Success!', 'The label has been created.'))
            .then(() => dispatch(push(`/labels`)))
    }
}

export function updateLabel(label) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${label.id}`,
            method: 'PUT',
            data: {
                id: label.id,
                name: label.display_name,
                label_type_id: label.label_type_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(updatedLabel(label)))
            .then(() => toastr.success('Success!', 'The label has been updated.'))
    };
}

export function deleteLabel(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${id}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedLabel(id)))
            .then(() => toastr.success('Success!', 'Label with ID ' + id + ' has been deleted.'))
    }
}

export function fetchLabelTranslations(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${id}/translations`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedLabelTranslations(response.data)))
    }
}

export function fetchLabelTranslation(labelId, translationId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${labelId}/translations/${translationId}`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedLabelTranslation(response.data)))
    };
}

export function createLabelTranslation(labelTranslationBySite, labelId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${labelId}/translations`,
            method: 'POST',
            data: {
                name: labelTranslationBySite.display_name,
                site_id: labelTranslationBySite.site_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchLabelTranslations(labelId)))
            .then(() => toastr.success('Success!', 'The translation has been successfully created!'))
    }
}

export function updateLabelTranslation(labelTranslationBySite, labelId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${labelId}/translations/${labelTranslationBySite.id}`,
            method: 'PUT',
            data: {
                name: labelTranslationBySite.display_name,
                site_id: labelTranslationBySite.site_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchLabelTranslations(labelId)))
            .then(() => toastr.success('Success!', 'The translation has been successfully updated!'))
    }
}

export function deleteLabelTranslation(labelId, translationId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/labels/${labelId}/translations/${translationId}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedLabelTranslation(translationId)))
            .then(() => toastr.success('Success!', 'Translation with ID ' + translationId + ' has been deleted.'))
    }
}


// WEBPACK FOOTER //
// ./src/containers/labels/thunks.js